import { SET_CURRENT } from 'reduxes/slices/current/actions'
import { SET_CURRENT_TITLE } from 'reduxes/slices/current/actions'

export function current(state = {}, action) {
  switch (action.type) {
    case SET_CURRENT:
      if (action.replaceState) {
        return action.currentObj
      } else {
        return {
          ...state,
          ...action.currentObj,
        }
      }
    case SET_CURRENT_TITLE:
      return {
        ...state,
        title: action.title,
      }
    default:
      return state
  }
}
